import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import ErrorBoundary from "@/components/ErrorBoundary";
import {
    sanitizePhoneNumber,
    formatPhoneNumber,
} from "@/utils/phone/phoneUtils";
import { useFacility } from "@/hooks/useFacility.tsx";

export const UnitError = () => {
    const options = useDisplayOptionContext();
    const mainFacilityId = options.facilityIds[0];
    const { facility, isLoading, error } = useFacility(mainFacilityId);

    const facilityPhone = facility?.phone;

    const sanitizedPhoneNumber = sanitizePhoneNumber(facilityPhone);
    const formattedPhoneNumber = formatPhoneNumber(facilityPhone);

    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <h2>
                        We're sorry, we are having trouble retrieving units at
                        this time.
                    </h2>
                </CardTitle>
            </CardHeader>
            <CardContent>
                {error ? (
                    "Oh no, there was an error! {error.status}"
                ) : isLoading ? (
                    <Skeleton className="tw:w-[200px] tw:h-[20px] tw:rounded-full" />
                ) : facility ? (
                    <ErrorBoundary>
                        <p>
                            For more information on unit availability, please
                            call{" "}
                            <a href={`tel:${sanitizedPhoneNumber}`}>
                                {formattedPhoneNumber}
                            </a>
                        </p>
                    </ErrorBoundary>
                ) : null}
            </CardContent>
        </Card>
    );
};
